var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level",class:_vm.active?'active':'',style:('background-image:url('+_vm.bgImg+') ;background-size:150px auto;background-position:top;background-color:'+_vm.bgColor+';left:'+_vm.left+'%'),on:{"click":function($event){_vm.startGame = true}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }